export class Reminder {
  id: number;
  topic: string;
  body: string;
  received_messageable_id: number;
  received_messageable_type: string;
  sent_messageable_id: number;
  sent_messageable_type: string;
  opened: boolean = false;
  recipient_delete: boolean = false;
  sender_delete: boolean = false;
  created_at: any;
  updated_at: any;
  ancestry: any;
  recipient_permanent_delete: boolean = false;
  sender_permanent_delete: boolean = false;
  start_date: any;
  created_by: any;
  reminderable_type: string;
  reminderable_id: number | undefined;
  matter_id: number | null;
  reminder_group_id: number;
  reminded_at: any;
  position: number;
  matter_name: string;
  start_date_str: any;
  start_time_str: any;
  valid: boolean = false;
  editing: boolean = false;
  start_time: any;
  end_date: any;
  rrule: string;
  rrule_text: string; //humanized version of recurring rule
  repeats_forever: boolean = false;
  start_date_struct: any;
  end_date_struct: any;
  delivery_methods: Array<any> = [];
  recipient_ids: Array<number> = [];
  snoozed_at: any;
  snoozed_at_str: any;
  topic_str: string;
  body_str: string;
  hovering: boolean = false;
  deleting: boolean = false;
  snoozing: boolean = false;
  dismissing: boolean = false;
  reminderable_title: string;
  reminderable_url: string;
  next_date_str: string;
  next_time_str: string;
  recurring_tooltip: string;
  tooltip: string;
  yearly_date: string;
  reminderable_title_str: string;
  end_date_str: string;
  end_time_str: string;
  next_occurrences: Array<any>;
  reminderable_type_str: string;
  reminderable_title_name: string;
  snoozed_till: any;
  matter_number: number;
  event_info: any;
  hideReminderableRow: boolean;

  validate(): boolean {
    if (this.start_date_str && this.start_time_str && this.matter_id && this.topic && this.body) this.valid = true;
    else this.valid = false;
    return this.valid;
  }
}
